export default "__VITE_ASSET__vnTHAQwB__"